import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';

/** Main application shell: sidebar + header (including the global filter bar) + routed content. */
export function AppLayout() {
  return (
    <div className="app-shell d-flex">
      <Sidebar />
      <div className="app-main flex-grow-1 d-flex flex-column min-vh-100">
        <Header />
        <main className="flex-grow-1 p-3 p-lg-4 bg-body-tertiary">
          <ErrorBoundary>
            <Suspense fallback={<LoadingSpinner label="Loading page…" />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
